(function (root, factory) {
  var api = factory();
  if (typeof module === "object" && module.exports) module.exports = api;
  if (root) root.BadgeBuzzZakekeLaunchIntent = api;
})(typeof window !== "undefined" ? window : globalThis, function () {
  "use strict";

  function value(input) {
    return String(input == null ? "" : input).trim();
  }

  function requiresCartLine(intent) {
    return value(intent) === "cart-edit";
  }

  var SUPPORTED_PRINTING_METHODS = {
    olantai: true,
    "apogee-name-tag-color-reflections": true,
  };

  function applyPrintingMethod(input, methodCode) {
    var original = value(input);
    var code = value(methodCode);
    if (!original || !SUPPORTED_PRINTING_METHODS[code]) return original;
    try {
      var url = new URL(original);
      url.searchParams.set("firstSidePrintingMethods[front]", code);
      url.searchParams.set("firstSidePrintingMethods[back]", code);
      return url.toString();
    } catch (error) {
      return original;
    }
  }

  function projectContinuationUrl(input) {
    var project = input || {};
    var productUrl = value(project.productUrl);
    var designId = value(project.designId);
    var currentUrl = value(project.currentUrl);
    if (!productUrl || !designId || !currentUrl) return "";

    try {
      var current = new URL(currentUrl);
      var target = new URL(productUrl, current);
      if (target.origin !== current.origin || target.pathname.indexOf("/products/") !== 0) return "";
      target.searchParams.set("bbDesign", designId);
      return target.toString();
    } catch (error) {
      return "";
    }
  }

  function canOpenProject(input) {
    var project = input || {};
    return Boolean(
      value(project.designId) &&
        value(project.productId) &&
        projectContinuationUrl({
          productUrl: project.productUrl,
          designId: project.designId,
          currentUrl: project.currentUrl,
        }),
    );
  }

  function canOpenRevision(input) {
    var revision = input || {};
    var token = value(revision.token);
    var designId = value(revision.designId);
    var productId = value(revision.productId);
    var fallbackUrl = value(revision.fallbackUrl);
    var currentUrl = value(revision.currentUrl);
    var quantity = Number(revision.quantity);
    if (
      !token ||
      !designId ||
      !/^\d+$/.test(productId) ||
      !Number.isSafeInteger(quantity) ||
      quantity < 1 ||
      !fallbackUrl ||
      !currentUrl
    ) return false;

    try {
      var current = new URL(currentUrl);
      var target = new URL(fallbackUrl, current);
      return Boolean(
        target.origin === current.origin &&
          target.pathname.indexOf("/products/") === 0 &&
          target.searchParams.get("bbDesign") === designId &&
          target.searchParams.get("bbRevision") === token,
      );
    } catch (error) {
      return false;
    }
  }

  function revisionSubmitUrl(token) {
    var signedToken = value(token);
    return signedToken
      ? "/apps/bb-portal/portal/v1/artwork-revisions/" +
          encodeURIComponent(signedToken) +
          "/submit"
      : "";
  }

  function revisionProductJsonUrl(input) {
    var revision = input || {};
    var fallbackUrl = value(revision.fallbackUrl);
    var currentUrl = value(revision.currentUrl);
    if (!fallbackUrl || !currentUrl) return "";
    try {
      var current = new URL(currentUrl);
      var target = new URL(fallbackUrl, current);
      if (
        target.origin !== current.origin ||
        !/^\/products\/[a-z0-9][a-z0-9-]*$/.test(target.pathname)
      ) return "";
      return target.pathname + ".js";
    } catch (error) {
      return "";
    }
  }

  function revisionLaunchFromFallback(input) {
    var revision = input || {};
    var product = revision.product || {};
    var lines = Array.isArray(revision.lines) ? revision.lines : [];
    var productId = value(product.id);
    var productHandle = value(product.handle);
    if (!/^\d+$/.test(productId) || !productHandle) return null;

    try {
      var current = new URL(value(revision.currentUrl));
      var target = new URL(value(revision.fallbackUrl), current);
      var designId = value(target.searchParams.get("bbDesign"));
      var token = value(target.searchParams.get("bbRevision"));
      if (
        target.origin !== current.origin ||
        target.pathname !== "/products/" + productHandle ||
        !designId ||
        !token
      ) return null;
      var line = lines.find(function (candidate) {
        return value(candidate && candidate.zakeke_design_id) === designId;
      });
      var quantity = Number(line && line.quantity);
      var launch = {
        intent: "paid-order-revision",
        token: token,
        designId: designId,
        productId: productId,
        productTitle:
          value(product.title) || value(line && line.title) || "Order artwork",
        quantity: quantity,
      };
      return canOpenRevision({
        token: launch.token,
        designId: launch.designId,
        productId: launch.productId,
        quantity: launch.quantity,
        fallbackUrl: revision.fallbackUrl,
        currentUrl: revision.currentUrl,
      })
        ? launch
        : null;
    } catch (error) {
      return null;
    }
  }

  function revisionPayload(input) {
    var revision = input || {};
    var designId = value(revision.designId);
    var quantity = Number(revision.quantity);
    if (!designId || !Number.isSafeInteger(quantity) || quantity < 1) return null;
    var previews = Array.isArray(revision.previews)
      ? revision.previews.map(value).filter(Boolean)
      : [];
    return {
      zakekeMessageType: 0,
      designId: designId,
      designID: designId,
      quantity: quantity,
      previews: previews,
    };
  }

  return {
    applyPrintingMethod: applyPrintingMethod,
    canOpenProject: canOpenProject,
    canOpenRevision: canOpenRevision,
    projectContinuationUrl: projectContinuationUrl,
    revisionLaunchFromFallback: revisionLaunchFromFallback,
    revisionPayload: revisionPayload,
    revisionProductJsonUrl: revisionProductJsonUrl,
    revisionSubmitUrl: revisionSubmitUrl,
    requiresCartLine: requiresCartLine,
  };
});
